export const challengesTranslations = {
  fr: {
    title: "Défis",
    seoDescription: "Participez aux défis hebdomadaires et comparez vos performances",
    weeklyChallenges: "Défis hebdomadaires",
    noActiveChallenge: "Aucun challenge actif pour le moment",
    noActiveChallengeDesc: "Les challenges sont lancés régulièrement. Revenez bientôt pour participer au prochain défi et gagner des XP !",
    nextChallengeSoon: "Le prochain challenge sera annoncé prochainement",
    backToDashboard: "Retour au tableau de bord",
    loadError: "Erreur lors du chargement des données",
    daysShort: "j",
    participants: "participants",
    goal: "Objectif",
    yourRank: "Votre classement",
    leaderboard: "Classement",
    leaderboardFor: "Classement pour: {{specialty}}",
    generalLeaderboard: "Classement général",
    noParticipants: "Aucun participant pour le moment",
    anonymous: "Anonyme",
    completed: "✓ Terminé",
    loadingLeaderboard: "Chargement du classement",
    loadingChallenges: "Chargement des défis",
  },
  en: {
    title: "Challenges",
    seoDescription: "Participate in weekly challenges and compare your performance",
    weeklyChallenges: "Weekly Challenges",
    noActiveChallenge: "No active challenge at the moment",
    noActiveChallengeDesc: "Challenges are launched regularly. Come back soon to participate in the next one and earn XP!",
    nextChallengeSoon: "The next challenge will be announced soon",
    backToDashboard: "Back to dashboard",
    loadError: "Error loading data",
    daysShort: "d",
    participants: "participants",
    goal: "Goal",
    yourRank: "Your rank",
    leaderboard: "Leaderboard",
    leaderboardFor: "Leaderboard for: {{specialty}}",
    generalLeaderboard: "General leaderboard",
    noParticipants: "No participants yet",
    anonymous: "Anonymous",
    completed: "✓ Completed",
    loadingLeaderboard: "Loading leaderboard",
    loadingChallenges: "Loading challenges",
  },
  es: {
    title: "Desafíos",
    seoDescription: "Participa en los desafíos semanales y compara tu rendimiento",
    weeklyChallenges: "Desafíos semanales",
    noActiveChallenge: "No hay desafíos activos en este momento",
    noActiveChallengeDesc: "Los desafíos se lanzan regularmente. ¡Vuelve pronto para participar en el próximo y ganar XP!",
    nextChallengeSoon: "El próximo desafío se anunciará pronto",
    backToDashboard: "Volver al panel",
    loadError: "Error al cargar los datos",
    daysShort: "d",
    participants: "participantes",
    goal: "Objetivo",
    yourRank: "Tu clasificación",
    leaderboard: "Clasificación",
    leaderboardFor: "Clasificación para: {{specialty}}",
    generalLeaderboard: "Clasificación general",
    noParticipants: "Aún no hay participantes",
    anonymous: "Anónimo",
    completed: "✓ Completado",
    loadingLeaderboard: "Cargando clasificación",
    loadingChallenges: "Cargando desafíos",
  },
};
